/* eslint-disable */
import { useEffect, useRef, useState } from "react";
import { useStores } from "../use.store";
import React from "react";
import Div100vh from "react-div-100vh";
import { observer } from "mobx-react-lite";
import deviceConfig from "../services/Config";
import { AdsumLoader, AdsumWebMap } from "@adactive/adsum-web-map";
import ACA from "@adactive/adsum-utils/services/ClientAPI";
import store from "../store";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Map } from "@adactive/arc-map";
import { getMedias } from "../store/app/mediaActions";
import { login } from "../store/app/authActions";
import axios from "axios";

const Splashscreen = observer(() => {
  const { generalStore } = useStores();
  const awmContainerRef = useRef(null);
  const { config, token, mapState } = useSelector((state) => {
    return {
      token: state.auth.token,
      config: state.auth.config,
      mapState: state.map.state,
    };
  }, shallowEqual);
  const dispatch = useDispatch();
  const [awm, setAwm] = useState(null);
  useEffect(() => {
    dispatch(login());
  }, []);

  useEffect(() => {
    if (token && config) initDevice();
  }, [token, config]);

  useEffect(() => {
    loadMap();
  }, [mapState]);
  const initDevice = () => {
    const pattern = /^([A-Za-z "/]{4,})$/;
    deviceConfig
      .init()
      .then(() => ACA.init(deviceConfig.config.api))
      .then(() => ACA.load())
      .then(() => {
        generalStore.stepLoading = generalStore.stepLoading + 1;
        const awMap = new AdsumWebMap({
          loader: new AdsumLoader({
            entityManager: ACA.entityManager, // Give it in order to be used to consume REST API
            deviceId: deviceConfig.config.map.deviceId,
          }),
          engine: {
            container: awmContainerRef.current, // The div DOMElement to insert the canvas into
          },
        });
        setAwm(awMap);
        generalStore.awm = awMap;
      })

      .then(() => {
        generalStore.stepLoading = generalStore.stepLoading + 1;
        generalStore.aca = ACA;
        generalStore.deviceConfig = deviceConfig;
        var allPOIS = ACA.getAllPois()
          .map((poi) => {
            const allPlaces = Array.from(poi.places.values).map((place) =>
              ACA.getPlace(place.value)
            );

            const categoryInfo = Array.from(poi.categories.values).map(
              (category) => ACA.getCategory(category.value)
            );

            poi.categories = categoryInfo;

            if (categoryInfo.name === "Amenities") {
              poi.description = "";
            }

            const places = _.sortBy(allPlaces, (x) => {
              return x.name.split("-")[1];
            })
              .map((place, index) => {
                if (pattern.test(place.name)) {
                  return place.name;
                } else {
                  if (index === 0) {
                    return place.name;
                  } else {
                    const placeNameSplit = place.name.split("-");
                    return placeNameSplit[1]
                      ? placeNameSplit[1]
                      : placeNameSplit[0];
                  }
                }
              })
              .join("/")
              .replace(/_/g, " ");

            const floor_id =
              allPlaces.length > 0 ? allPlaces[0].floor_id : null;
            const floor = allPlaces.length > 0 ? allPlaces[0] : null;

            const shape_id =
              allPlaces.length > 0 ? allPlaces[0].shape_id : null;

            const place_id = allPlaces.length > 0 ? allPlaces[0].id : null;

            const tags =
              Array.from(poi.tags.values).length > 0
                ? ACA.getTagBy({
                    id: Array.from(poi.tags.values)[0].value,
                  })[0].name
                : null;

            return {
              ...poi,
              places,
              tags,
              floor,
              floor_id,
              shape_id,
              place_id,
              categoryInfo,
            };
          })
          .filter(
            (poi) =>
              poi.categoryInfo &&
              poi.categoryInfo.length > 0 &&
              poi.categoryInfo[0].name !== "Amenities"
          );
        generalStore.allCategories = ACA.getAllCategories().filter((e) => {
          return e.client_id != null;
        });
        generalStore.pois = allPOIS.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });

        // fetch from adsign
        getPoiAdsign();
        getTags();
        getInformations();
        // end
        generalStore.stepLoading = generalStore.stepLoading + 1;
        dispatch(getMedias());
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getTags = async () => {
    // get tag from adsign json
    axios
      .get(`${config.baseUrl}/tag`, {
        params: {
          siteId: config.adsignSiteId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (!response.data.data) {
          console.log(`bagian getTags not ok`, response);
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.data.data;
      })
      .then((data) => {
        try {
          generalStore.tags = data;
        } catch (e) {
          console.error("Error parsing JSON:", e);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const getInformations = async () => {
    // get information from adsign json
    axios
      .get(`${config.baseUrl}/information/list`, {
        params: {
          siteId: config.adsignSiteId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (!response.data.data) {
          console.log(`getInformations not ok`, response);
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.data.data;
      })
      .then((data) => {
        try {
          generalStore.information = data;
        } catch (e) {
          console.error("Error parsing JSON:", e);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const getPoiAdsign = () => {
    // fetch from adsign json, then combine with adsum data
    axios
      .get(`${config.baseUrl}/poi/populate`, {
        params: {
          siteId: config.adsignSiteId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (!response.data.data) {
          console.log(`bagian getPoiAdsign not ok ${response}`);
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.data.data; // Get the raw text first
      })
      .then((jsonData) => {
        try {
          generalStore.pois.map((poiAdsum) => {
            const matchingItem = jsonData.find(
              (poiAdsign) => poiAdsum.client_id === poiAdsign._id
            );

            // Merge adsum and adsign data
            if (matchingItem) {
              // Merge adsum description
              const poiAdsumDesc = JSON.parse(poiAdsum.description);

              if (matchingItem.categoryIds) {
                poiAdsumDesc.categoryIds = matchingItem.categoryIds;
              }
              if (matchingItem.description) {
                if (matchingItem.description.includes("*****")) {
                  const descs = matchingItem.description.split("*****");
                  poiAdsumDesc.description = descs[0];
                  poiAdsum.customLabel = descs[1];
                } else {
                  poiAdsumDesc.description = matchingItem.description;
                }
              }
              if (matchingItem.direction) {
                poiAdsum.customLabel = matchingItem.direction;
              }
              if (matchingItem.firstMedias) {
                poiAdsumDesc.firstMedias = matchingItem.firstMedias;
              }
              if (matchingItem.floor) {
                poiAdsumDesc.floor = matchingItem.floor;
              }
              if (matchingItem.location) {
                poiAdsumDesc.location = matchingItem.location;
              }
              if (matchingItem.logo) {
                poiAdsumDesc.logo = matchingItem.logo;
              }
              if (matchingItem.opentime) {
                poiAdsumDesc.opentime = matchingItem.opentime;
              }
              if (matchingItem.phone) {
                poiAdsumDesc.phone = matchingItem.phone;
              }
              if (matchingItem.secondMedias) {
                poiAdsumDesc.secondMedias = matchingItem.secondMedias;
              }
              if (matchingItem.subCategoryIds) {
                poiAdsumDesc.subCategoryIds = matchingItem.subCategoryIds;
              }
              if (matchingItem.tags) {
                poiAdsumDesc.tags = matchingItem.tags;
              }
              if (matchingItem.url) {
                poiAdsumDesc.url = matchingItem.url;
              }

              poiAdsum.description = JSON.stringify(poiAdsumDesc);

              // Merge adsum tags
              if (matchingItem.tags) {
                poiAdsum.tags = matchingItem.tags;
              }
              if (matchingItem.uniqueId) {
                poiAdsum.uniqueId = matchingItem.uniqueId;
              }
            }

            return poiAdsum;
          });
        } catch (e) {
          console.error("Error parsing JSON:", e);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const loadMap = async () => {
    if (awm) {
      const getFloors = Array.from(awm.objectManager.floors.values()).sort(
        (a, b) => {
          return a.altitude - b.altitude;
        }
      );

      generalStore.floors = getFloors;
      generalStore.activeFloor = awm.defaultFloor;
      if (awm.cameraManager.control.enableRotate) {
        awm.cameraManager.control.enableRotate = true;
      }

      setTimeout(() => {
        generalStore.loading = false;
      }, 1000);
    }
  };
  const renderMap = () => {
    return (
      <Map
        store={store}
        awm={awm}
        isOpen={true}
        autoSelectOnClick={false}
        className={`w-full h-full absolute z-10`}
        highlightColor="#DD3D3D"
        zoom={{
          min: 100,
          max: 1300,
        }}
      >
        <div id="adsum-web-map-container" ref={awmContainerRef} />
      </Map>
    );
  };
  const logoSupremeCourt = "logo-supreme-court";
  const logoFamilyJustice = "logo-family-justice";
  const logoStateCourt = "logo-state-court";

  return (
    <Div100vh>
      <div className="w-full h-full bg-splashscreen-bg bg-no-repeat bg-cover bg-bottom flex flex-col justify-center items-center overflow-hidden">
        <img
          src={require(`../assets/images/${logoFamilyJustice}.png`)}
          alt=""
          className="w-[50%] h-[80px] md:h-[250px] md:w-[570px] bg-no-repeat bg-center bg-contain mb-4"
        />

        <div className="w-2/3 h-[4px] bg-[#FFFFFF0F] rounded-full">
          <div
            className={`w-[${
              (generalStore.stepLoading / 3) * 100
            }%] h-[4px] bg-[#E09948] rounded-full`}
          ></div>
        </div>
        <div className="w-2/3 flex flex-row items-center justify-center mt-2 text-[8px] gap-1">
          {generalStore.stepLoading < 3 && (
            <span className="text-primary text-[12px]">
              {Math.ceil((generalStore.stepLoading / 3) * 100)}%
            </span>
          )}
          <span
            className={
              generalStore.stepLoading == 3
                ? "text-primary text-[12px]"
                : "text-[white] text-[12px]"
            }
          >
            {generalStore.stepLoading == 3
              ? "Welcome to Family Justice Courts Singapore"
              : "Preparing your experience"}
          </span>
        </div>
        <div class="absolute bottom-12 flex items-center justify-center w-full flex-col gap-2">
          <span className="text-white text-[10px]">Managed by :</span>
          <img
            src={require("../assets/images/sg-court-logo.png")}
            className="h-[35px] w-[75px]"
          />
        </div>
      </div>
      {renderMap()}
    </Div100vh>
  );
});

export default Splashscreen;
